import { ActionBase } from '../../../core/store/action/ActionBase';
import { LookupModel } from '../../../common/models/LookupModel';

export const ADD_ALL_USER_GROUPS  = '[Customer] User Add Group';

export class AddAllGroupsToUserAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ADD_ALL_USER_GROUPS ;

  constructor(public payload: { userKey: string, allowAllGroups: boolean, lookUpModels:LookupModel[] }) { }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/AddAllGroupsToUserAction.ts